import React from "react";

const Stats = ({ title, total }) => {
  return (
    <div className="mt-5">
      <div className="stats shadow bg-primary text-neutral w-full">
        <div className="stat text-center">
          <div className="stat-title font-bold">{title}</div>
          <div className="stat-value">{total}</div>
          {/* <div className="stat-desc">21% more than last month</div> */}
        </div>
      </div>
    </div>
  );
};

export default Stats;
